import React from 'react';
import PaginationTable from '../PaginationTable';
import {Button} from 'reactstrap';
import {formatDate, formatFloat, numberPadding } from '../../../utils/formatting';
import Filters from './Filters';
import DetailModal from './SurveyDetail';

export default class SurveysReport extends React.Component {

    constructor(props) {
        super(props);
        this.fetchReports = this._fetchReports.bind(this);
        this.filterChange = this._filterChange.bind(this);
        this.state = {
            filters : {},
            detailSurvey : null,
        };
    }

    componentWillMount() {
        this.fetchReports();
    }

    _filterChange(data) {
        this.setState({
            filters : data,
        }, this.fetchReports);
    } 

    _fetchReports(page) {
        this.props.fetchReports('surveys', page, this.state.filters);
    }

    render() {
        const data = this.props.reportsState.surveys;
        const paginationData = data ? data.data : {};
        return (
            <div>
                <Filters 
                    requestXlsx={this.props.requestXlsx}
                    report="surveys"
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    users={this.props.users}  
                    onFilterChange={this.filterChange}  
                />
                {
                    (data||{}).fetching ?
                        <div className="container my-2">
                            <i className="fa fa-spinner fa-spin"></i> Cargando
                        </div>
                    :
                        <PaginationTable {...paginationData}
                            territories={this.props.territories}
                            coordinations={this.props.coordinations}
                            pageChange={this.fetchReports}
                            showDetail={(survey) => this.setState({detailSurvey : survey})}
                            headerComponent={renderHeader}
                            rowComponent={renderRow}/>
                }
                
                <DetailModal
                    isOpen={this.state.detailSurvey !== null}
                    toggle={() => this.setState({detailSurvey : null})}
                    report={this.state.detailSurvey}/>
            </div>
        );
    }
}


function renderHeader(props) {
    return (
        <tr>
            <th>
                Territorio
            </th>
            <th>
                Coordinación
            </th>   
            <th>
                SIC
            </th>
            <th>
                Nombre cliente
            </th>
            <th>
                No. ejecutivo
            </th>
            <th>
                Nombre ejecutivo
            </th>
            <th>
                Fecha de solicitud
            </th>
            <th>
                Promedio
            </th>
            <th></th>
        </tr>
    );
} 

function renderRow(props) {
    const report = props.item;
    const territory = props.territories.data[report.user.territory_id];
    const coordination = props.coordinations.data[report.user.coordination_id];
    const answers = report.survey_answers;
    let total = 0;
    const avg = answers.reduce((acum, elem) => {
            let value = parseInt(elem.answer, 10);
            if( ! isNaN(value)) {
                total++;
                return value + acum;
            }
            return acum;
            
        }, 0) / (total || 1);
    return (
        <tr>
            <td>
                {territory ? territory.name : 'Desconocido'}
            </td>
            <td>
                {coordination ? coordination.name : 'Desconocida'}
            </td>
            <td>
                {report.client.sic}
            </td>
            <td>
                {report.client.full_name}
            </td>
            <td>
                {numberPadding(report.user.emp_number, 6)}
            </td>
            <td>
                {report.user.name}
            </td>
            <td>
                {formatDate(report.created_at)}
            </td>
            <td className={avg < 3 ? 'text-danger' : 'text-success'}>
                {
                    formatFloat(avg)
                }
            </td>
            <td>
                <Button color="secondary" size="sm" onClick={() => props.showDetail(report)}>Detalle</Button>
            </td>
        </tr>
    );    
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/SurveysReport.jsx
 **/